module.exports = __webpack_public_path__ + "static/media/import_amazon.63f8cba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/assets/images/import_amazon.png
// module id = 1108
// module chunks = 0